export enum AppConfigActionTypes {
  AppConfigSetIsReady = 'AppConfigSetIsReady',
  AppConfigSetDrawWrapper = 'AppConfigSetDrawWrapper',
  AppConfigSetPreloaded = 'AppConfigSetPreloaded',
  AppConfigSetAppPreloaded = 'AppConfigSetAppPreloaded',
}
